import { Cache } from '@/client/apiPage/cache/cache.js';

export const createNumberCache = (defaultNumber: number = -1): Cache<number> => {
    let cachedNumber = defaultNumber;

    return {
        set(value: number): void {
            cachedNumber = value;
        },
        get(): number {
            return cachedNumber;
        },
    };
};
